import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";

import { useEffect } from "react";

import liff from "@line/liff";

import { HOME_DIR } from "./Utills/constants";

import Theme1Screen from "./Components/Main/Theme1";
import Theme2Screen from "./Components/Main/Theme2";
import Theme3Screen from "./Components/Main/Theme3";
import Theme4Screen from "./Components/Main/Theme4";
import Theme5Screen from "./Components/Main/Theme5";
import Theme6Screen from "./Components/Main/Theme6";
import Theme7Screen from "./Components/Main/Theme7";
import Theme8Screen from "./Components/Main/Theme8";
import Theme9Screen from "./Components/Main/Theme9";
import Theme10Screen from "./Components/Main/Theme10";
import Theme11Screen from "./Components/Main/Theme11";
import SpinWheel from "./Components/Main/Wheel";
import Theme12Screen from "./Components/Main/Theme12";
import Theme13Screen from "./Components/Main/Theme13";
import Theme14Screen from "./Components/Main/Theme14";
import Theme15Screen from "./Components/Main/Theme15";
import Theme16Screen from "./Components/Main/Theme16";
import Theme17Screen from "./Components/Main/Theme17";
import Theme18Screen from "./Components/Main/Theme18";
import CardGame from "./Components/Main/Card";

function App() {

  useEffect(() => {

    liff.ready.then(() => {

    });
  }, []);
  return (
    <Router basename={`${HOME_DIR}`}>
      <Routes>
        {/* <Route exact path="/" element={<Theme1Screen />} /> */}
        {/* <Route exact path="/" element={<Theme2Screen />} /> */}
        {/* <Route exact path="/" element={<Theme3Screen />} /> */}
        <Route exact path="/" element={<Theme4Screen />} />
        {/* <Route exact path="/" element={<Theme5Screen />} /> */}
        {/* <Route exact path="/" element={<Theme6Screen />} /> */}
        {/* <Route exact path="/" element={<Theme7Screen />} /> */}
        {/* <Route exact path="/" element={<Theme8Screen />} /> */}
        {/* <Route exact path="/" element={<Theme9Screen />} /> */}
        {/* <Route exact path="/" element={<Theme10Screen />} /> */}
        {/* <Route exact path="/" element={<Theme11Screen />} /> */}
        {/* <Route exact path="/" element={<Theme12Screen />} /> */}
        {/* <Route exact path="/" element={<Theme13Screen />} /> */}
        {/* <Route exact path="/" element={<Theme14Screen />} /> */}
        {/* <Route exact path="/" element={<Theme15Screen />} /> */}
        {/* <Route exact path="/" element={<Theme16Screen />} /> */}
        {/* <Route exact path="/" element={<Theme17Screen />} /> */}
        {/* <Route exact path="/" element={<Theme18Screen />} /> */}

        {/* <Route exact path="/" element={<SpinWheel />} /> */}
        {/* <Route exact path="/" element={<CardGame />} /> */}



      </Routes>
    </Router>
  );
}

export default App;
